import axios from "axios";
import appConfig from "../config/appConfig";
import UserService from "./UserService";

const runtimeEnv = window.__ENV || {};

const apiClient = axios.create({
  baseURL:
    runtimeEnv.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    "/api",
});

apiClient.interceptors.request.use(async (config) => {
  const nextConfig = { ...config };

  if (appConfig.auth.enableKeycloak) {
    const token = await UserService.getValidToken();
    if (token) {
      nextConfig.headers = {
        ...nextConfig.headers,
        Authorization: `Bearer ${token}`,
      };
    }
  }

  return nextConfig;
});

export default apiClient;
